import React, { useState } from "react";
import {
    Box,
    CardMedia,
    Typography,
    IconButton,
    Grid,
    Container,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { Card, CardContainer } from "./Card";

const TruncatedTypography = styled(Typography)(({ theme }) => ({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
        overflow: "visible",
        position: "absolute",
        backgroundColor: theme.palette.background.paper,
        zIndex: 2,
        // boxShadow: theme.shadows[2],
        padding: theme.spacing(1),
        // borderRadius: theme.shape.borderRadius,
        width: "90%",
    },
}));

const PostCarousel = ({ data, containerTitle = "Top Posts" }) => {
    const [startIndex, setStartIndex] = useState(0);
    const itemsToShow = 4;

    const handleNext = () => {
        if (startIndex + itemsToShow < data.length) {
            setStartIndex((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex((prev) => prev - 1);
        }
    };

    const formatNumber = (count) => {
        return count >= 1000 ? (count / 1000).toFixed(1) + "K" : count;
    };

    return (
        <Card>
            <Container
                maxWidth="lg"
                sx={{ margin: "-20px", paddingRight: "-50px" }}
            >
                <Box sx={{ position: "relative", py: 4 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Typography variant="highlightSemibold" component="h2">
                            {containerTitle}
                        </Typography>
                        <Box>
                            <IconButton
                                onClick={handlePrev}
                                disabled={startIndex === 0}
                            >
                                <ArrowCircleLeftOutlinedIcon />
                            </IconButton>
                            <IconButton
                                onClick={handleNext}
                                disabled={
                                    startIndex + itemsToShow >= data.length
                                }
                            >
                                <ArrowCircleRightOutlinedIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Grid container spacing={2}>
                        {data
                            .slice(startIndex, startIndex + itemsToShow)
                            .map((item) => (
                                <Grid item xs={12} sm={6} md={3} key={item.id}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            window.open(item.url, "_blank")
                                        }
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.image_url}
                                            alt={item.title}
                                            sx={{
                                                height: 280,
                                                objectFit: "cover",
                                                borderRadius: 2,
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                background:
                                                    "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)",
                                                padding: 2,
                                                borderRadius: "0 0 8px 8px",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    alignItems: "center",
                                                    color: "white",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <VisibilityOutlinedIcon fontSize="small" />
                                                    <Typography variant="captionRegular">
                                                        {formatNumber(
                                                            item.engagement
                                                                ?.views || 0
                                                        )}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <FavoriteBorderOutlinedIcon fontSize="small" />
                                                    <Typography variant="captionRegular">
                                                        {formatNumber(
                                                            item.engagement
                                                                ?.likes || 0
                                                        )}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <ChatBubbleOutlineOutlinedIcon fontSize="small" />
                                                    <Typography variant="captionRegular">
                                                        {formatNumber(
                                                            item.engagement
                                                                ?.comments || 0
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            pt: 1.5,
                                            position: "relative",
                                        }}
                                    >
                                        <TruncatedTypography
                                            variant="contentRegular"
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            {item.description ||
                                                "The creator economy in India"}
                                        </TruncatedTypography>
                                    </Box>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            </Container>
        </Card>
    );
};

export default PostCarousel;
